/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Skeleton } from '@coursera/cds-core';

import { ItemCompleteButton } from 'bundles/widget/components/itemCompleteButton/ItemCompleteButton';

import { getNativeWidgetRenderer } from '../registry';
import type { NativeWidgetConfig, NativeWidgetRendererBaseProps } from '../types';
import { ExpandableContainer } from './ExpandableContainer';

const LOADING_HEIGHT = 600;

const styles = {
  completeButton: css`
    margin-top: var(--cds-spacing-200);
  `,
};

type NativePluginRendererProps = NativeWidgetRendererBaseProps<NativeWidgetConfig>;

export const NativePluginRenderer = ({
  config,
  isComplete = false,
  nextItem,
  showPopupButton,
  renderCustomContainer,
  markComplete,
  markStarted,
}: NativePluginRendererProps) => {
  const Plugin = getNativeWidgetRenderer(config?.widgetRenderConfigurationType);

  if (!Plugin) {
    return null;
  }

  return (
    <ExpandableContainer showPopupButton={showPopupButton} renderCustomContainer={renderCustomContainer}>
      <React.Suspense fallback={<Skeleton height={LOADING_HEIGHT} variant="rect" />}>
        <Plugin config={config} isComplete={isComplete} markStarted={markStarted} />
      </React.Suspense>

      {markComplete && (
        <ItemCompleteButton
          css={styles.completeButton}
          isComplete={isComplete}
          markComplete={markComplete}
          nextItem={nextItem}
        />
      )}
    </ExpandableContainer>
  );
};
